/* Cœur du thème : chargé sur toutes les pages (layout/theme.liquid, <script type="module">).
   Maquette : js/main.js + js/chrome.js + js/include.js (initReveal). Les sections n'ont plus besoin de fetch : le HTML est rendu par Liquid.
   Contenu : en-tête (fond au défilement, menu mobile), annonce fermable, carrousels, révélations, panier, mouvement et ambiance (import dynamique
   non bloquant : si un module échoue, le site fonctionne sans), capture UTM (réglage), rescan dans l'éditeur de thème. */
import { $, $$, on, store, isDesignMode } from 'mi/dom';
import { initReveal } from 'mi/reveal';
import 'mi/cart';

const MI = window.MI || {};
const FLAGS = MI.flags || {};
const design = isDesignMode();
const root = document.documentElement;
if (design) root.classList.add('design-mode');

/* ---------- En-tête : transparent sur le hero, crème après défilement ---------- */
function initHeader(scope = document) {
  const header = $('.site-header', scope) || $('.site-header');
  if (!header || header.dataset.miInit) return;
  header.dataset.miInit = '1';
  const first = $('main > :first-child');
  if (first && ($('[data-header-tone="dark"]', first) || first.matches('[data-header-tone="dark"]'))) header.classList.add('on-dark-hero');
  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
  onScroll(); on(window, 'scroll', onScroll, { passive: true });

  initMenu(header);
}

/* ---------- Menu mobile : panneau plein écran (dialog non modal : la barre d'en-tête reste active), accordéon Boutique, focus piégé, Échap, fond inerte ---------- */
function initMenu(header) {
  const btn = $('[data-menu-toggle]', header); const menu = $('#mi-menu');
  if (!btn || !menu) return;
  const FOCUS = 'a[href], button:not([disabled])';
  const visible = (el) => el.getClientRects().length > 0;
  let inerted = [];
  const setInert = (on) => {
    if (!on) { inerted.forEach((el) => { el.inert = false; }); inerted = []; return; }
    for (let n = header; n && n !== document.body; n = n.parentElement) {
      for (const s of n.parentElement.children) {
        if (s !== n && !/^(SCRIPT|STYLE|LINK)$/.test(s.tagName) && !s.inert) { s.inert = true; inerted.push(s); }
      }
    }
  };
  const isOpen = () => btn.getAttribute('aria-expanded') === 'true';
  const set = (open, back) => {
    if (open === isOpen()) return;
    menu.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('no-scroll', open); header.classList.toggle('menu-open', open); setInert(open);
    if (open) { const f = $$(FOCUS, menu).find(visible); if (f) f.focus({ preventScroll: true }); } else if (back) btn.focus({ preventScroll: true });
  };
  const toggles = $$('[data-mm-toggle]', menu);
  const fold = (t, open) => { const p = document.getElementById(t.getAttribute('aria-controls')); t.setAttribute('aria-expanded', String(open)); if (p) p.hidden = !open; };
  toggles.forEach((t) => {
    fold(t, t.getAttribute('aria-expanded') === 'true');
    on(t, 'click', () => { const open = t.getAttribute('aria-expanded') !== 'true'; toggles.forEach((o) => fold(o, o === t && open)); });
  });
  const cur = $('[aria-current="page"]', menu);
  if (cur) { const sub = cur.closest('.mm-sub'); const t = sub && toggles.find((x) => x.getAttribute('aria-controls') === sub.id); if (t) toggles.forEach((o) => fold(o, o === t)); }
  on(btn, 'click', () => set(!isOpen(), true));
  on(menu, 'click', (e) => { if (e.target.closest('a')) set(false); });
  on(document, 'click', (e) => { if (isOpen() && e.target.closest('[data-cart-open]')) set(false); }, true);
  on(document, 'keydown', (e) => {
    if (!isOpen()) return;
    if (e.key === 'Escape') { set(false, true); return; }
    if (e.key !== 'Tab') return;
    const f = $$(FOCUS, header).filter(visible); if (!f.length) return;
    const first = f[0]; const last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  on(window, 'pageshow', () => set(false));
  window.matchMedia('(min-width: 900px)').addEventListener('change', (e) => { if (e.matches) set(false); });
}

/* ---------- Barre d'annonce : fermeture mémorisée pour la session ---------- */
function initAnnounce() {
  const bar = $('[data-mi-announce]');
  if (!bar) return;
  if (store.get('mi-announce-closed') === '1' && !design) { bar.hidden = true; root.style.setProperty('--announce-h', '0px'); return; }
  const close = $('[data-announce-close]', bar);
  if (close) on(close, 'click', () => { bar.hidden = true; root.style.setProperty('--announce-h', '0px'); store.set('mi-announce-closed', '1'); });
}

/* ---------- Carrousels (flèches, défilement avec accroche CSS) ---------- */
function initCarousels(scope = document) {
  $$('.carousel', scope).forEach((c) => {
    const vp = $('.carousel__viewport', c); if (!vp || c.dataset.miInit) return;
    c.dataset.miInit = '1';
    const prev = $('[data-prev]', c); const next = $('[data-next]', c);
    if (prev) on(prev, 'click', () => vp.scrollBy({ left: -vp.clientWidth, behavior: 'smooth' }));
    if (next) on(next, 'click', () => vp.scrollBy({ left: vp.clientWidth, behavior: 'smooth' }));
  });
}

/* ---------- Attribution : copie des utm_* dans les attributs du panier (réglage, désactivé par défaut) ---------- */
function captureUtm() {
  if (!FLAGS.captureUtm) return;
  try {
    const params = new URLSearchParams(window.location.search); const attrs = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((k) => { const v = params.get(k); if (v) attrs['_' + k] = v; });
    if (!Object.keys(attrs).length || store.get('mi-utm') === '1') return;
    store.set('mi-utm', '1');
    fetch((MI.routes && MI.routes.cartUpdate) || '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
  } catch (e) { /* attribution facultative */ }
}

/* ---------- Mouvement et ambiance : imports dynamiques non bloquants ---------- */
async function initEffects(scope = document) {
  initReveal(scope);
  if (design) return;
  if (FLAGS.ambient !== false) import('mi/ambient').then((m) => m.initAmbient(scope)).catch(() => {});
  if (FLAGS.motion !== false && !scope.__miMotion) {
    scope.__miMotion = true;
    import('mi/motion').then(() => document.dispatchEvent(new CustomEvent('mi:sections-ready'))).catch(() => {});
  }
}

function boot() {
  initHeader(); initAnnounce(); initCarousels(); initEffects(); captureUtm();
  document.dispatchEvent(new CustomEvent('mi:sections-ready'));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

/* ---------- Éditeur de thème : une section ajoutée, déplacée ou modifiée est réinitialisée ---------- */
document.addEventListener('shopify:section:load', (e) => {
  const scope = e.target;
  initCarousels(scope); initReveal(scope);
  if (scope.querySelector('.site-header')) initHeader(scope);
  if (FLAGS.ambient !== false) import('mi/ambient').then((m) => m.initAmbient(scope)).catch(() => {});
  document.dispatchEvent(new CustomEvent('mi:sections-ready'));
});
